import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import DateRangePicker from "../DateRangePicker";
import { fetchV3AllLocals } from "../../shared/queries";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import SelectInput from "../SelectInput";
import { BaseSelectItem } from "../../types";
import FormField from "../FormField";

export default function ExportContracts({
  onChange,
}: {
  onChange: (data: any) => void;
}) {
  const [fromDate, setFromDate] = useState<string>(
    dayjs().format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState<string>(
    dayjs().add(1, "day").format("YYYY-MM-DD")
  );

  const [local_key, setLocalKey] = useState<string>("");

  const { t } = useTranslation();

  const { data: locals, isFetching: isFetchingLocals } = useQuery(
    "localsv3",
    fetchV3AllLocals
  );

  useEffect(() => {
    onChange({
      action: "CONTRACTS",
      day_from: fromDate,
      day_to: toDate,
      local_key: local_key,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local_key, fromDate, toDate]);

  return (
    <div className={"p-4"}>
      <div className="text-lg font-semibold">{t("export.contract")}</div>

      <div className="mt-4 text-gray-600 text-sm">
        {t("export.contractDesc")}
      </div>

      <div className="mt-6 flex flex-col space-y-4">
        <DateRangePicker
          inputFormat={"YYYY-MM-DD"}
          displayFormat={"DD-MM-YYYY"}
          outputFormat={"DD-MM-YYYY"}
          size={"sm"}
          value={fromDate + " -> " + toDate}
          onChange={(value) => {
            const { from, to } = value as any;
            setFromDate(dayjs(from).format("YYYY-MM-DD"));
            setToDate(dayjs(to).format("YYYY-MM-DD"));
          }}
        />
        <FormField label={t("navigation.apartments")}>
          <SelectInput<BaseSelectItem, false>
            menuPosition="fixed"
            isLoading={isFetchingLocals}
            menuShouldScrollIntoView={false}
            onChange={(item) => {
              if (item) setLocalKey(item.value);
            }}
            options={
              locals && locals.results
                ? locals.results.map((local) => {
                    return {
                      label: local.name,
                      value: local.local_key,
                    };
                  })
                : []
            }
          />
        </FormField>
      </div>
    </div>
  );
}
